<template lang="pug">
div.navigation-item(:class="{ 'active-item': slug === currentPath,'active-circle': (!patientListToggle && slug === 'patients'), 'disabled': disabled }")
  div.nav-btn(@click="onNavSelect")
    v-icon.icon {{ icon }}
  v-menu.menu(activator="parent" z-index="2004" v-if="dropdownMenu && dropdownMenu.length")
    v-list
      v-btn(
        v-for="item in dropdownMenu"
        :key="item"
        variant="plain"
        @click="onDropDownClick(item)"
      )
        v-label {{ item.title }}
</template>

<script setup>
/**
 *  Events to update the tab active state.
 */
const emit = defineEmits(['on:active', 'on:select'])

const props = defineProps({
  /**
   *  current path
   */
  currentPath: {
    type: String,
    required: true,
  },
  patientListToggle: {
    type: Boolean,
    required: false,
  },
  /**
   *  item path
   */
  path: {
    type: String,
    required: true,
  },
  /**
   *  item slug
   */
  slug: {
    type: String,
    required: true,
  },
  /**
   *  icon that need to be shown
   */
  icon: {
    type: String,
    required: true,
  },
  /**
   *  item dropdown menu
   */
  dropdownMenu: {
    type: Array,
    required: false,
  },
  disabled: {
    type: Boolean,
    required: false,
  },
})

const onNavSelect = () => {
  if (!props.disabled) emit('on:active')
}

const onDropDownClick = (item) => {
  emit('on:select', item)
}
</script>

<style lang="stylus" scoped>
.navigation-item
  padding 0
  margin 12px 0
  position relative;
  min-height 48px
  &.disabled
    opacity 0.5
    cursor pointer
    pointer-events none
.nav-btn
  display flex
  justify-content center
  align-items center
  cursor pointer
  padding 12px 20px
  overflow visible
  color var(--white, #FFFFFF) !important
  text-decoration none

  :deep() path
    fill var(--white, #FFFFFF)
  &::before
    content ''
    position absolute
    border-radius 50%
    width 48px
    height 48px
    top 50%
    left 50%
    transform translate(-50%, -50%) scale(0)
    background-color var(--ghost-white, #F7F8FA)
    opacity 0
  &:hover
    :deep() path
      fill var(--japanese-indigo, #194355)
    &::before
      transform translate(-50%, -50%) scale(1)
      opacity 1
.active-item .nav-btn:hover::before
  display none
.active-item
  padding-left 12px !important
  &:before, &:after
    content ''
    position absolute
    width 25px
    height 48px
  &:before
    top 48px
    right 0
    border-radius 0 16px 0 0
    box-shadow 0 -16px 0 0 var(--ghost-white, #F7F8FA)
  &:after
    bottom 48px
    left calc(100% - 25px)
    border-radius 0 0 16px 0
    box-shadow 0 16px 0 0 var(--ghost-white, #F7F8FA)
  .nav-btn
    background-color var(--ghost-white, #F7F8FA)
    border-radius 50% 0% 0% 50%
    padding-left 8px !important
    :deep() path
      fill var(--japanese-indigo, #194355)
    &:hover::before
      display none
.active-item
  &.active-circle
    padding-left 0 !important
    .nav-btn
      padding-left 20px !important
      background-color transparent !important
      border-radius 0
      &:hover::before
        display block
    .nav-btn::before
      content ''
      position absolute
      border-radius 50%
      width 48px
      height 48px
      transform none !important
      transition none !important
      top 3%
      left 18%
      background-color var(--ghost-white, #F7F8FA)
      opacity 1
.menu
  .v-list
      padding 0
      min-width 180px
      .v-btn
        height 30px
        cursor pointer
        display flex
        align-items center
        width 100%
        justify-content flex-start
        text-transform capitalize
        border-bottom 1px solid var(--bright-gray, #EEEFF2)
        border-radius 0px
        transition background-color 0.3s ease, color 0.3s ease
        &:hover
          background-color var(--midnight-green, #004457)
          .v-label
            color var(--white, #FFFFFF)
        .v-icon
            font-size var(--fs-12, 0.75rem)
            pointer-events none
            margin-right 5px
        .v-label
            font-size var(--fs-12, 0.75rem)
            pointer-events none
            opacity inherit
            color black
.icon
  width 24px
  height 24px
</style>
